import React from "react";
import { useNavigate } from "react-router-dom";
import { useWallet } from "../hooks/useWallet";
import {
    Wallet as WalletIcon,
    Gift,
    CreditCard,
    ArrowUpRight,
    Download,
    // Info,
} from "lucide-react";

import { Sidebar } from "./Sidebar";
import { Header } from "./Header";
import { MobileHeader } from "./MobileHeader";

// const transactions = [
//     {
//         id: 1,
//         date: "18 Jun 2025, 11:24 AM",
//         amount: "₹5,000.00",
//         paymentMethod: "Visa •••• 4242",
//         status: "Success",
//         transactionId: "pay_Od9FZ3akLm2",
//     },
//     {
//         id: 2,
//         date: "03 Jun 2025, 09:15 AM",
//         amount: "₹3,000.00",
//         paymentMethod: "UPI",
//         status: "Success",
//         transactionId: "pay_Od6HJ2pQkN8",
//     },
//     {
//         id: 3,
//         date: "18 May 2025, 08:40 AM",
//         amount: "₹2,000.00",
//         paymentMethod: "Mastercard •••• 5555",
//         status: "Success",
//         transactionId: "pay_Oc4KJ8zXtP1",
//     },
//     {
//         id: 4,
//         date: "02 May 2025, 10:05 AM",
//         amount: "₹5,000.00",
//         paymentMethod: "Visa •••• 4242",
//         status: "Success",
//         transactionId: "pay_Oc1LJ9mVbR7",
//     },
//     {
//         id: 5,
//         date: "20 Apr 2025, 06:32 PM",
//         amount: "₹2,000.00",
//         paymentMethod: "UPI",
//         status: "Success",
//         transactionId: "pay_Oa8FH3qLmD4",
//     },
// ];

function StatusBadge({ status }) {
    return (
        <span className={`status-badge ${status.toLowerCase()}`}>
            {status}
        </span>
    );
}

function WalletCard({
    title,
    value,
    subtitle,
    button,
    icon,
    iconClass,
    redirectTo,
}) {
    const navigate = useNavigate();
    return (
        <div className="wallet-card">

            <div className="wallet-card-header">

                <div className="wallet-title">

                    {title}

                    {/* <Info size={16} /> */}

                </div>

                <div className={`wallet-icon ${iconClass}`}>

                    {icon}

                </div>

            </div>

            <div className="wallet-value">

                ₹{value}

            </div>

            <div className="wallet-subtitle">

                {subtitle}

            </div>

            <button className="secondary-btn" onClick={() => navigate(redirectTo)}>

                {button}

            </button>

        </div>
    );
}

export function Wallet() {
    const navigate = useNavigate();
    const {
        data,
        isLoading,
        error,
    } = useWallet();

    if (isLoading) {
        return (

            <div className="page-state">

                <div className="page-state-spinner" />

                <h2>

                    Loading...

                </h2>

                <p>

                    We're fetching your latest data.

                </p>

            </div>

        );
    }

    if (error) {
        return (

            <div className="page-state">

                <div className="page-state-icon">

                    !

                </div>

                <h2>

                    Something went wrong

                </h2>

                <p>

                    We couldn't load this page. Please try refreshing or come back in a moment.

                </p>

                <button

                    className="primary-btn"

                    onClick={() => window.location.reload()}

                >

                    Try Again

                </button>

            </div>

        );
    }

    return (

        <div className="overview-page">

            <MobileHeader />

            <Sidebar />

            <div className="overview-content">
                <Header
                    title="Wallet"
                    subtitle="Manage your balances, top up your wallet and view history."
                    action={
                        <button className="primary-btn" onClick={() => navigate('/top-up-wallet')}>

                            <WalletIcon size={18} />

                            Top Up Wallet

                        </button>
                    }
                />

                <div className="wallet-grid">

                    <WalletCard
                        title="Balance"
                        value={data.balance}
                        subtitle="For acquiring customers"
                        button="Top Up Wallet"
                        icon={<WalletIcon size={28} />}
                        iconClass="blue"
                        redirectTo="/top-up-wallet"
                    />

                    <WalletCard
                        title="Referral Earnings"
                        value={data.referralEarnings}
                        subtitle="From offer redemptions"
                        button="View Earnings"
                        icon={<Gift size={28} />}
                        iconClass="green"
                    />

                    <div className="wallet-card auto-topup-card">

                        <div className="auto-topup-header">

                            <div className="wallet-title">

                                Auto Top-up

                                {/* <Info size={16} /> */}

                            </div>

                            <span className="status-badge active">

                                Active

                            </span>

                        </div>

                        <div className="auto-row">

                            <span>When balance goes below</span>

                            <strong>₹500.00</strong>

                        </div>

                        <div className="auto-row">

                            <span>Top up amount</span>

                            <strong>₹5,000.00</strong>

                        </div>

                        <div className="auto-row">

                            <span>Payment method</span>

                            <strong>

                                <CreditCard size={16} />

                                Visa •••• 4242

                            </strong>

                        </div>

                        <button className="secondary-btn">

                            Manage Auto Top-up

                        </button>

                    </div>

                </div>

                {/* Top-up History table continues in Part 2 */}

                <div className="dashboard-card wallet-history-card">

                    <div className="card-header">

                        <h2>Top-up History</h2>

                        <button className="text-button">

                            View all transactions

                            <ArrowUpRight size={18} />

                        </button>

                    </div>

                    <table className="activity-table">

                        <thead>

                            <tr>

                                <th>Date & Time</th>
                                <th>Amount</th>
                                <th>Payment Method</th>
                                <th>Status</th>
                                <th>Transaction ID</th>
                                <th>Invoice</th>

                            </tr>

                        </thead>

                        <tbody>

                            {data.transactions.map((transaction) => (

                                <tr key={transaction.transactionId}>

                                    <td>

                                        {new Date(transaction.createdAt).toLocaleString("en-IN", {
                                            day: "2-digit",
                                            month: "short",
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}

                                    </td>

                                    <td>
                                        <strong
                                            className={
                                                transaction.amount >= 0
                                                    ? "positiveBlue"
                                                    : "withdrawal"
                                            }
                                        >
                                            {transaction.amount >= 0
                                                ? `+₹${transaction.amount}`
                                                : `-₹${Math.abs(transaction.amount)}`}
                                        </strong>
                                    </td>

                                    <td>

                                        {transaction.paymentMethod}

                                    </td>

                                    <td>

                                        <StatusBadge
                                            status={transaction.status}
                                        />

                                    </td>

                                    <td>

                                        {transaction.transactionId}

                                    </td>

                                    <td>

                                        <button className="invoice-button">

                                            <Download size={18} />

                                        </button>

                                    </td>

                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

                <div className="wallet-banner">

                    <div className="wallet-banner-left">

                        <div className="wallet-banner-icon">

                            <WalletIcon size={28} />

                        </div>

                        <div>

                            <h3>

                                Running low on balance?

                            </h3>

                            <p>

                                Top up your wallet to keep your offers live and continue
                                acquiring customers.

                            </p>

                        </div>

                    </div>

                    <button className="primary-btn" onClick={() => navigate('/top-up-wallet')}>

                        <WalletIcon size={18} />

                        Top Up Wallet

                    </button>

                </div>

            </div>

        </div>

    );

}